import React from "react";
import "../css/members.scss";

const SocialIcons = ({ member }) => (
  <div className="member-socials">
    {member.linkedin && (
      <a
        href={member.linkedin}
        className="social-icon"
        aria-label="LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="images/linkedin.svg" alt="linkedin" />
      </a>
    )}
    {member.instagram && (
      <a
        href={member.instagram}
        className="social-icon"
        aria-label="Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="images/instagram.svg" alt="instagram" />
      </a>
    )}
    {member.facebook && (
      <a
        href={member.facebook}
        className="social-icon"
        aria-label="Facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="images/facebook.svg" alt="facebook" />
      </a>
    )}
  </div>
);

const MemberCard = ({ member }) => (
  <article className="member-card">
    <div className="member-card-image-wrap">
      {member.image ? (
        <img
          src={member.image}
          alt={member.name}
          className="member-card-image"
        />
      ) : (
        <div className="member-card-image-placeholder" />
      )}
    </div>
    <h3 className="member-name">{member.name}</h3>
    <p className="member-role">{member.role}</p>
    {member.description && (
      <p className="member-description">{member.description}</p>
    )}
    <SocialIcons member={member} />
  </article>
);

const visibleMembers = (members = []) =>
  members.filter((member) => !member.hidden);

const TeamContent = ({ data }) => {
  const { title1, title2 } = data;
  const board = visibleMembers(data.board);
  const teachers = visibleMembers(data.teachers);

  return (
    <section className="members-section" id="team">
      <div className="members-container">
        {board.length > 0 && (
          <>
            <div className="members-header">
              <h2 className="members-title">{title1}</h2>
              <div className="members-title-bar" aria-hidden="true" />
            </div>
            <div className="members-grid members-grid--3">
              {board.map((member, index) => (
                <MemberCard key={index} member={member} />
              ))}
            </div>
          </>
        )}

        {teachers.length > 0 && (
          <>
            <div className={`members-header${board.length > 0 ? " members-header--second" : ""}`}>
              <h2 className="members-title">{title2}</h2>
              <div className="members-title-bar" aria-hidden="true" />
            </div>
            <div className="members-grid members-grid--2">
              {teachers.map((teacher, index) => (
                <MemberCard key={index} member={teacher} />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

const Team = ({ data, standalone = true }) => {
  if (!data || !data.board || !data.teachers) return null;

  if (!standalone) {
    return <TeamContent data={data} />;
  }

  return (
    <div className="members-page members-page--team">
      <TeamContent data={data} />
    </div>
  );
};

export default Team;
